export const dataEvaluation = [
  {
    id: "อาจารย์ที่ปรึกษาประจำชั้น",
    name: "อาจารย์ที่ปรึกษาประจำชั้น",
  },
  {
    id: "อาจารย์ที่ปรึกษาประจำรายวิชา",
    name: "อาจารย์ที่ปรึกษาประจำรายวิชา",
  },
  {
    id: "อาจารย์ที่ปรึกษาวิทยานิพนธ์",
    name: "อาจารย์ที่ปรึกษาวิทยานิพนธ์",
  }
];
//
